import './assets/main.css'
import './assets/layout.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import './router/permission.js'

// 引用自定义组件库
import Components from './utils/components.js'

// 引用自定义方法
import Prototypes from './utils/prototypes.js'
import { setupIcons } from './plugins/icons/index.js'

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(Components)
app.use(Prototypes)

setupIcons(app)

app.mount('#app')
